<template>
  <div class="track">
    <panel-head
      title="转化追踪"
      subtitle="Transformation tracking"
    ></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">
        转化追踪<up-button
          type="primary"
          class="fr"
          @click="operateTrack('add')"
          >新增API回传</up-button
        >
      </h3>
      <!-- <div class="panel-content__select-list">
        <div class="fr mr20">
          <up-button type="primary" @click="batchStartAndStopTrack(selectedIds, true, true)">批量开启</up-button>
          <up-button class="is-warning" type="primary" @click="batchStartAndStopTrack(selectedIds, true, false)">批量暂停</up-button>
        </div>
      </div> -->
      <div class="panel-content__table-wrap">
        <up-table
          :page="page"
          @up:selection-change="handleUpSelectChange"
          @current-change="handlePageChange"
          @size-change="handlePageChange"
          show-overflow-tooltip
          align="center"
        >
          <template slot="up:operate">
            <up-table-column width="50" fixed="right" label="开关">
              <template slot-scope="{ row }">
                <up-switch
                  v-if="row.status !== 2"
                  :value="row.status === 1"
                  @change="startAndStopTrack(row)"
                ></up-switch>
              </template>
            </up-table-column>
            <up-table-column width="250" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <up-button
                  v-if="row.status === 0"
                  class="is-edit"
                  size="small"
                  type="primary"
                  @click="operateTrack('edit', row)"
                  >编辑</up-button
                >
                <up-button
                  class="is-view"
                  size="small"
                  type="primary"
                  @click="operateTrack('view', row)"
                  >查看</up-button
                >
                <up-button
                  v-if="row.status !== 2"
                  class="is-remove"
                  size="small"
                  type="primary"
                  @click="removeTrack(row)"
                  >停止</up-button
                >
                <up-button
                  class="is-mini"
                  size="small"
                  type="primary"
                  @click="operateTrack('copy', row)"
                  >复制</up-button
                >
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { PanelHead } from '@/global/components';

export default {
  name: 'Track',
  components: {
    PanelHead
  },
  data() {
    return {
      platform: '',
      page: new this.$page()
    };
  },
  created() {
    this.platform = this.$route.meta.platform;
    this.getTracks();
  },
  methods: {
    ...mapActions([
      'track/getTracks',
      'track/stopTrack',
      'track/openTrack',
      'track/removeTrack'
    ]),
    handleUpSelectChange({ selection, selectAll }) {
      this.selectedIds = selection.map(v => v.id);
    },
    handlePageChange() {},
    startAndStopTrakc() {},
    removeTrack(row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的转化吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await this['track/removeTrack']({ platform: this.platform, id: row.id })
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) this.$message.error('删除转化失败')
            else if (res.code === 1) this.$message.success('删除转化成功')
          }
          if (instance.confirmButtonLoading) instance.confirmButtonLoading = false;
          done()
        }
      }).then(_ => {
        this.getTracks()
      }).catch(_ => {
        // console.log()
      })
    },
    async startAndStopTrack(row) {
      let err, res;
      const isStart = row.status === 0
      let text = isStart ? '开启' : '暂停';
      if (isStart) {
        [err, res] = await this['track/openTrack']({
          platform: this.platform,
          id: row.id
        });
      } else {
        [err, res] = await this['track/stopTrack']({
          platform: this.platform,
          id: row.id
        });
      }
      if (err || res.code !== 1) this.$message.error(`${text}转化失败`);
      else {
        this.$message.success(`${text}转化成功`);
        this.getTracks();
      }
    },
    operateTrack(type, row) {
      this.$router.push(`/track/${type}${type !== 'add' ? '/' + row.id : ''}`);
    },
    async getTracks(params = {}) {
      const { pageSize, currentPage } = this.page;
      this.page.loading = true;
      try {
        const [
          ,
          {
            data: { header, data, total }
          }
        ] = await this['track/getTracks']({
          platform: this.platform,
          params: {
            per_page: pageSize,
            page: currentPage,
            ...params
          }
        });
        this.page.setData({ header, data, total });
        this.loadings = Array.from({ length: data.length }, Boolean);
      } catch (error) {
        this.page.loading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
